export default __webpack_public_path__ + "static/media/MySQL.a75fa02f.png";